import { configureStore } from '@reduxjs/toolkit'

import { marketplaceApi } from '@/entities/marketplace'
import { officeApi } from '@/entities/office'
import { organizationApi, organizationRoleApi } from '@/entities/organization'
import { profileApi } from '@/entities/profile'
import { serviceApi } from '@/entities/service'
import { settingsApi } from '@/entities/settings'
import { uploadApi } from '@/entities/upload'
import { userApi } from '@/entities/user'

import { authApi } from '@/shared/api'

const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [serviceApi.reducerPath]: serviceApi.reducer,
    [marketplaceApi.reducerPath]: marketplaceApi.reducer,
    [organizationApi.reducerPath]: organizationApi.reducer,
    [organizationRoleApi.reducerPath]: organizationRoleApi.reducer,
    [officeApi.reducerPath]: officeApi.reducer,
    [uploadApi.reducerPath]: uploadApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
  },

  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware().concat([
      authApi.middleware,
      profileApi.middleware,
      userApi.middleware,
      serviceApi.middleware,
      marketplaceApi.middleware,
      organizationApi.middleware,
      organizationRoleApi.middleware,
      officeApi.middleware,
      uploadApi.middleware,
      settingsApi.middleware,
    ])
  },

  devTools: import.meta.env.DEV,
})

export default store
